import type { FilterChip } from '@/components/filter-bar'
import type { ListarCredenciaisFiltro, StatusCredencial } from '@/types/credencial'
import { STATUS_CREDENCIAL } from '@/types/credencial'

export interface FiltroCredenciais {
  busca: string
  situacao: StatusCredencial
  operadoraId: string
  clienteId: string
}

export const filtroVazio: FiltroCredenciais = {
  busca: '',
  situacao: STATUS_CREDENCIAL.Todas,
  operadoraId: '',
  clienteId: '',
}

const CAMPOS_PAINEL = ['situacao', 'operadoraId', 'clienteId'] as const

const preenchido = (campo: keyof FiltroCredenciais, filtro: FiltroCredenciais): boolean =>
  campo === 'situacao'
    ? filtro.situacao !== STATUS_CREDENCIAL.Todas
    : filtro[campo].trim() !== ''

export const contarFiltrosDoPainel = (filtro: FiltroCredenciais): number =>
  CAMPOS_PAINEL.filter((campo) => preenchido(campo, filtro)).length

export const paraFiltroApi = (
  filtro: FiltroCredenciais,
  pageSize: number,
): ListarCredenciaisFiltro => ({
  pageNumber: 1,
  pageSize,
  busca: filtro.busca || null,
  situacao: filtro.situacao,
  operadoraId: filtro.operadoraId || null,
  clienteId: filtro.clienteId || null,
})

const ROTULOS: Record<keyof FiltroCredenciais, string> = {
  busca: 'Busca',
  situacao: 'Situação',
  operadoraId: 'Operadora',
  clienteId: 'Cliente',
}

export const montarChips = (
  filtro: FiltroCredenciais,
  remover: (campo: keyof FiltroCredenciais) => void,
): FilterChip[] =>
  (['busca', ...CAMPOS_PAINEL] as (keyof FiltroCredenciais)[])
    .filter((campo) => preenchido(campo, filtro))
    .map((campo) => ({
      key: campo,
      label: ROTULOS[campo],
      value: filtro[campo],
      onRemove: () => remover(campo),
    }))
